import type { IconName } from "@/components/ui/Icon.vue";

export interface NavItem {
  to: string;
  label: string;
  icon: IconName;
  admin?: boolean;
  match?: RegExp;
}
export const navigation: { label: string; items: NavItem[] }[] = [
  { label: "Work", items: [
    { to: "/", label: "Mission Control", icon: "grid" },
    { to: "/ask", label: "Ask Majlis", icon: "message" },
    { to: "/tickets", label: "Tickets", icon: "branch", match: /^\/(tickets|runs)(\/|$)/ },
    { to: "/guide", label: "Guide", icon: "book" },   // how to do things, step by step (H-167)
  ] },
  { label: "Build", items: [
    { to: "/connectors", label: "Connectors", icon: "link" },   // workspaces bring their own connections (H-153)
    { to: "/agents", label: "Agents", icon: "sparkle" },
    { to: "/workspaces", label: "Workspaces", icon: "user" },
    { to: "/projects", label: "Jira projects", icon: "layers" },
    { to: "/skills", label: "Skills", icon: "list" },
    { to: "/notes", label: "Notes", icon: "file" },
    { to: "/onboarding", label: "Connect a project", icon: "plus", admin: true },
  ] },
  { label: "Govern", items: [
    { to: "/decisions", label: "Decisions", icon: "check" },
    { to: "/budgets", label: "Budgets", icon: "dollar", admin: true },
    { to: "/sirah-channels", label: "Sirah channels", icon: "message", admin: true },
    { to: "/bindings", label: "Bindings", icon: "lock" },
    { to: "/readiness", label: "Repo readiness", icon: "shield" },
  ] },
  { label: "More", items: [
    { to: "/map", label: "Code map", icon: "map" },
    { to: "/labs", label: "Code map labs", icon: "flask", admin: true, match: /^\/labs(\/|$)/ },   // three prototypes (2026-10-21)
    { to: "/brief", label: "Brief", icon: "brief" },
    { to: "/architecture", label: "Architecture", icon: "layers" },
    { to: "/compare", label: "Compare", icon: "compare" },
    { to: "/flows", label: "All flows", icon: "play", match: /^\/(flows|run)(\/|$)/ },
    { to: "/configs", label: "Configurations", icon: "settings" },
    { to: "/schedules", label: "Schedules", icon: "calendar" },
    { to: "/mappings", label: "Mappings", icon: "link", admin: true },
    { to: "/lineage", label: "Everything connected", icon: "branch" },
  ] },
];
